<div class="regular-content">
    <ng-container *ngFor="let item of items; let i = index">

            <div class="item" [class.active]="item.isActive"
                *ngIf="!item.isClickable">
                {{item.name}}
            </div>

            <div class="item clickable"
                 [class.active]="item.isActive"
                 *ngIf="item.isClickable && !item.routerLink"
                 (click)="notifyMe(i)">
                {{item.name}}
            </div>

            <a class="item clickable"
                *ngIf="item.isClickable && item.routerLink"
               [class.active]="item.isActive"
               [routerLink]="item.routerLink"
               [queryParams]="item.queryParams"
               (click)="notifyMe(i)">
                {{item.name}}
            </a>

            <div class="separator" *ngIf="i != (items.length-1)">
                <fa-icon [icon]="iconChevronRight"></fa-icon>
            </div>

    </ng-container>
</div>
<ng-content select=".additional-content"></ng-content>
